export default __webpack_public_path__ + "static/media/698c8138bef5ee6e68b656e4153654c4.md";